import axios from 'axios';

export const postEmailData = async (data) => {
  try {
    const response = await axios.post('SERVER_ENDPOINT', data, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return { success: response.status === 200 };
  } catch (error) {
    console.error('Error sending email:', error);
    return { success: false };
  }
};
